import request from "../utils/request"

/**
 * 商品列表的api
 */
export function productList(params) {
  return request({
    url: 'api/Equipment/KeyConfigs',
    method: 'get',
    params: {
      dtuNo: params.dtuNo
    }
  })
}

export function getKeyConfig(params) {
  return request({
    url: 'api/Equipment/GetKeyConfigBySort',
    method: 'get',
    params: {
      ...params
    }
  })
}


export function getEquipInfo(params) {
  return request({
    url: 'api/Equipment/Get',
    method: 'get',
    params: {
      dtuNo: params.dtuNo
    }
  })
}
// export function productList(params) {
//   return request({
//     url: 'api/Equipment/CupTypes',
//     method: 'get',
//     params: {
//       dtuNo: params.dtuNo
//     }
//   })
// }

export function productDetail(params) {
  return request({
    url: '/api/Beverage/CupType?id='+params.beverageId,
    method: 'get',
    params: {
      id: params.beverageId
    }
  })
}

/**
 * 新增订单
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrder(data) {
  return request({
    url: '/api/Order/Add',
    method: 'post',
    data: data
  })
}

export function getAppId(param){
  return request({
    url:'/api/Account/GetCollectionConfigurationByDtuNo?dtuNo='+param.dtuNo,
    method:'get',
    param: {
      dtuNo: param.dtuNo
    }
  })
}

/**
 * 获取openId
 * @param param
 * @returns {*}
 */
export function getOpenId(param){
  return request({
    url:'/api/Account/GetWeChatUserInfo?code='+param.code+'&dtuNo='+param.dtuNo,
    method:'get',
    param: {
      code:param.code,
      dtuNo:param.dtuNo
    }
  })
}

/**
 * 微信支付下单
 */
export function wxPay(data) {
  return request({
    url: '/api/Payment/WxUnifiedOrder',
    method: 'post',
    data:data
  })
}

export function aliPay(data) {
  return request({
    url: '/api/Payment/AliUnifiedOrder',
    method: 'post',
    data:data
  })
}


/**
 * 根据订单号查询订单
 */
export function getOrder(param) {
  return request({
    url: '/api/Order/GetByNo?orderNo='+param.orderNo,
    method: 'get'
  })
}

/**
 * 免费模式打杯
 */
export function produceBeverageByOrder(param) {
  return request({
    url: '/api/EquipmentOperation/ProduceBeverageByOrder?orderNo='+param.orderNo,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/productApi.js